import { render, staticRenderFns } from "./PatientCoursesFilters.vue?vue&type=template&id=6df7f91b&"
import script from "./PatientCoursesFilters.vue?vue&type=script&lang=js&"
export * from "./PatientCoursesFilters.vue?vue&type=script&lang=js&"
import style0 from "./PatientCoursesFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports